export default class Deferred<T> {
    public get promise(): Promise<T> {
        return this._promise;
    }

    public resolve(value: T): void {
        this._resolve(value);
    }

    public reject(value?: any): void {
        this._reject(value);
    }

    private _resolve: (value: T) => void = () => {};
    private _reject: (value?: T) => void = () => {};

    private _promise: Promise<T> = new Promise<T>((resolve, reject) => {
        this._reject = reject;
        this._resolve = resolve;
    });
}
